import { useMemo } from "react";
import { useAssetsPrice } from "./useAssetPrice";
import { useTreasuryBalance } from "./web3DataContext";
import { assetToFiat } from "../utils/math";
import { getAssetDecimals } from "../utils/asset";
var useTreasuryAccount = function () {
    var _a = useTreasuryBalance(), balances = _a.data, balanceLoading = _a.loading;
    var prices = useAssetsPrice().prices;
    var accounts = useMemo(function () {
        var accounts = Object.keys(balances).map(function (asset) {
            return {
                asset: asset,
                balance: balances[asset],
                value: parseFloat(assetToFiat(balances[asset], prices[asset].price, getAssetDecimals(asset))),
                loading: balanceLoading || prices[asset].loading,
            };
        });
        accounts.sort(function (a, b) { return (a.value < b.value ? 1 : -1); });
        return accounts;
    }, [balanceLoading, balances, prices]);
    return {
        accounts: accounts,
        total: accounts.reduce(function (acc, curr) { return acc + curr.value; }, 0),
        loading: balanceLoading,
    };
};
export default useTreasuryAccount;
//# sourceMappingURL=useTreasuryAccount.js.map